import { KeyRound } from 'lucide-react';
import { Link } from 'react-router';
import { useSession } from '@/entities/session/hooks/use-session';
import { useTranslation } from '@/shared/i18n/use-translation';

export function SessionExpiredBanner() {
  const session = useSession();
  const { t } = useTranslation();
  if (!session?.expired) return null;
  return (
    <div className="flex flex-wrap items-center justify-center gap-2 border-b bg-warn/15 px-4 py-2 text-sm">
      <KeyRound className="size-4" />
      <span>{t('Your session has expired. Your changes are still saved on this device.')}</span>
      <Link to="/sign-in" className="font-medium underline underline-offset-4">
        {t('Sign in')}
      </Link>
    </div>
  );
}
